import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const TableContainer = styled.div`
  width: 100%;
  max-height: 340px;

  overflow-y: auto;

  border: 1px solid #c4c4c4;
  /* align-self: center; */

  ::-webkit-scrollbar {
    width: 0.25rem;
  }
  ::-webkit-scrollbar-thumb {
    background: lightgray;
  }
`;

export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;

  td {
    vertical-align: middle;
    height: 4rem;
  }

  thead {
    th {
      text-align: start;
      background: #585e66;
      position: sticky;
      top: 0;

      color: #eff1f5;
      font-family: Sora;
      font-size: 1rem;
      font-style: normal;
      font-weight: 600;
      line-height: normal;

      height: 2.7rem;
    }
  }
  tbody {
    overflow-y: auto;

    ::-webkit-scrollbar {
      width: 0.25rem;
    }
    ::-webkit-scrollbar-thumb {
      background: lightgray;
    }
  }
`;

export const THTarefa = styled.th`
  padding-left: 2rem;
  width: 19.6%;
`;

export const THStartDate = styled.th`
  width: 14.4%;
`;

export const THDuration = styled.th`
  width: 14%;
`;

export const THEndingDate = styled.th`
  width: 18.4%;
`;

export const THStatus = styled.th`
  max-width: 17.4%;
`;

export const THACC = styled.th`
  min-width: 16.2%;
`;

export const TRLine = styled.tr`
  font-size: 0.85rem;
  background: ${({ checked }) => (checked ? "#cff8e7" : "#fff")};
  transition: background 2s ease-in-out;
`;

export const TDTarefa = styled.td`
  padding-left: 2rem;
  width: 19.6%;
`;

export const TDStartDate = styled.td`
  width: 14.4%;
`;

export const TDDuration = styled.td`
  width: 14%;
`;

export const TDEndingDate = styled.td`
  width: 18.4%;
`;
export const TaskDate = styled.span`
  align-items: center;
  display: flex;
  width: 8.8rem;

  padding: 0.2rem 0.3rem;
  border-radius: 0.2rem;
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.74rem;
  line-height: 0.95rem;

  background-color: ${({ status }) =>
    status === "doing"
      ? "#49B446"
      : status === "done"
        ? "#118052"
        : status === "doneLate"
          ? "#9F2D1D"
          : status === "pending"
            ? "#EFF1F5"
            : "#EB5757"};

  color: ${({ status }) => (status === "pending" ? "#7E858F" : "#FFFFFF")};

  path {
    stroke: ${({ status }) => (status === "pending" ? "#7E858F" : "#FFFFFF")};
  }
`;

export const TDStatus = styled.td`
  max-width: 17.4%;
`;

export const TDACC = styled.td`
  display: flex;
  min-width: 16.2%;
  align-items: center;
`;

export const StatusFormat = styled.span`
  padding: 0.2rem 0.7rem;
  border-radius: 0.2rem;
  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.74rem;
  line-height: 0.95rem;

  background-color: ${({ status }) =>
    status === "doing"
      ? "#F8E47C"
      : status === "pending"
        ? "#EFF1F5"
        : status === "done"
          ? "#118052"
          : "#FFBAAB"};

  color: ${({ status }) =>
    status === "doing"
      ? "#786A23"
      : status === "pending"
        ? "#7E858F"
        : status === "done"
          ? "#EFF1F5"
          : "#D93333"};
`;

export const Title = styled.span`
  font-family: Sora;
  font-style: normal;
  font-weight: 600;
  font-size: 1.125rem;
  line-height: 1.4375rem;
  color: #212326;
  padding: 1rem;
`;

export const Avatar = styled.img`
  height: 2rem;
  width: 2rem;
  border-radius: 1rem;
  margin-right: 1rem;
  margin-left: 0.5rem;
`;
